<div class="row">
  <div class="createCPPOuter cppCreateOrderPage">

    <div class="create-cpp-page">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToLandingPage()">CPP Order</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor xs-pr-0">
              <span *ngIf="webOrderNumber==0">Create Order</span>
              <span *ngIf="webOrderNumber>0">Web Order # : {{webOrderNumber}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <!--Ship to - Confirmation Email Section-->
        <div class="row">

          <!--Sold To Select List-->
          <div class=" col-md-4 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!soldToAccount">
            <ng-select name="ddlSoldTo"
                       [items]="soldToFacility"
                       class="custom-select-grower grower-add-drop"
                       [class.ng-select-disabled]="!soldToAccount"
                       [virtualScroll]="true"
                       [(ngModel)]="soldToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="true"
                       bindValue="accountNumber"
                       placeholder="Sold To: (Will Display after selection of Ship To):"
                       [loading]="soldToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       data-testid="ddl-sold-to">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Ship To Select List-->
          <div class=" col-md-4 material-select withBordr">
            <ng-select name="ddlShipTo"
                       [items]="shipToFacilityList"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="shipToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="isEditMode || readOnlyAccess"
                       bindValue="accountNumber"
                       placeholder="Ship To:"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)"
                       data-testid="ddl-ship-to-search">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-ship-to-option_'+item.accountNumber">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Deliver To Select List-->
          <div class=" col-md-4 material-select withBordr" [class.cpp-create-soldTo]="!deliverToAnotherLocation">
            <ng-select name="ddlDeliverTo"
                       [items]="deliverToList"
                       class="custom-select-grower pb-0 grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="deliverToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [disabled]="(!deliverToAnotherLocation || shipToAccount ==null || shipToAccount ==undefined || readOnlyAccess)"
                       placeholder="Deliver To:"
                       [loading]="deliverToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getDeliverTo($event)"
                       (clear)="getDeliverTo($event)"
                       data-testid="ddl-deliver-to">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-deliver-to-option_'+item.accountNumber">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="pt-1 checkbox-color">
              <mat-checkbox class="custom-checkbox"
                            [disabled]="readOnlyAccess"
                            [style.display]=""
                            [checked]=""
                            (change)="UpdateDeliverToSelection($event.checked)"
                            (input)="hasHeaderInfoChanged('Customer Pickup');"
                            [indeterminate]=""
                            [(ngModel)]="deliverToAnotherLocation"
                            data-testid="ddl-deliver-to-checkbox"></mat-checkbox>
              I want this delivered to another location.
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 specialInst padding-t4">
            <mat-form-field class="example-full-width">
              <label class="checkbox-color">Shipping Instructions:</label>
              <textarea style="resize:none;height:auto;" matInput rows="6"
                        (input)="hasHeaderInfoChanged('Special Instructions');"
                        [maxLength]="500"
                        [readonly]="readOnlyAccess"
                        [(ngModel)]="specialInstructionText"
                        data-testid="ddl-shipping-instruction"></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 purchaseOrder margin-t12">
            <mat-form-field class="wide100">
              <mat-label>Customer PO#:</mat-label>
              <input matInput type="text" name="purchaseOrder" (keypress)="keyPressAlphaNumeric($event,1)"
                     (input)="enablePlaceOrderAndSaveOrderDraft();hasHeaderInfoChanged('PO');"
                     [(ngModel)]="purchaseOrder"
                     [readonly]="readOnlyAccess"
                     [maxLength]="25"
                     data-testid="ddl-customer-po">
            </mat-form-field>
          </div>
          <div class="col-md-4 purchaseOrder margin-t12" *ngIf="isShowNonSubEmail">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Contact Email Address:</mat-label>
              <input matInput type="text" name="accountEmail" maxlength="500"
                     placeholder="(Separate multiple email addresses by a semi-colon)"
                     [readonly]="readOnlyAccess"
                     [(ngModel)]="accountEmail"
                     [pattern]="emailPattern"
                     (blur)="validateEmail()"
                     (input)="hasHeaderInfoChanged('Email Address');"
                     [errorStateMatcher]="matcher"
                     data-testid="ddl-cpp-email">
              <mat-error *ngIf="isNotValid">
                This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-4 checkbox-color margin-t35">
            Customer Pickup:  <mat-checkbox #CustomerPickupCheck class="custom-checkbox margin-l10"
                                            [disabled]="readOnlyAccess"
                                            [style.display]=""
                                            [checked]=""
                                            (input)="hasHeaderInfoChanged('Customer Pickup');"
                                            [indeterminate]=""
                                            [(ngModel)]="isCustomerPickup"
                                            (change)="customerPickupChange();"
                                            matTooltip="Select For Customer Pickup" [matTooltipPosition]="'above'"
                                            data-testid="ddl-customer-pickup"></mat-checkbox>
          </div>
        </div>

        <div class="row" *ngIf="isShowPackagedContactDetails">
          <div class=" col-md-4 material-select withBordr updateFontSize required">
            <ng-select name="ddlPackagedContactName"
                       [items]="cppPackagedDeliveryInstructionList"
                       class="custom-select-grower grower-add-drop"
                       [(ngModel)]="cppPackagedContactInfo"
                       bindLabel="contactName"
                       bindValue="contactNamePhoneNumber"
                       placeholder="Contact Name:"
                       [closeOnSelect]="true"
                       [searchFn]="packagedContactNameSearchFn"
                       (change)="getPackagedContactPhone($event)"
                       (clear)="getPackagedContactPhone($event)"
                       data-testid="ddl-packaged-contact-name-search"
                       [addTag]="true"
                       (keypress)="keyPressAlphaNumericWithSpace($event)"
                       [typeahead]="inputPackagedContactName$"
                       (blur)="createNewPackagedContact()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div *ngIf="item.contactId" class="dropdown-template" [attr.data-testid]="'ddl-packaged-contact-name-option_'+index">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.contactName}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-4 purchaseOrder margin-t12">
            <mat-form-field class="wide100">
              <mat-label>Contact Phone Number:</mat-label>
              <input matInput type="text" name="packagedContactNumber"
                     (input)="hasHeaderInfoChanged('Bulk Number');enablePlaceOrderAndSaveOrderDraft()"
                     (keypress)="keyPressPhone($event)"
                     (paste)="onPhonePaste($event, pkgPhone.control)"
                     [(ngModel)]="pkgContactNumber"
                     #pkgPhone="ngModel"
                     [readonly]="readOnlyAccess"
                     required
                     [maxLength]="20"
                     [pattern]="phonePattern"
                     data-testid="txt-packaged-contact-number">
              <mat-error *ngIf="pkgPhone.invalid && pkgPhone.touched">Please enter a 10 digit phone number</mat-error>
            </mat-form-field>
          </div>
          <div class=" col-md-4 material-select withBordr updateFontSize">
            <ng-select name="ddlDeliveryInstructions"
                       [items]="deliveryInstructionsCodeList"
                       [multiple]="true"
                       class="custom-select-grower grower-add-drop"
                       [(ngModel)]="cppDeliveryInstructionCode"
                       bindLabel="id"
                       bindValue="id"
                       placeholder="Delivery Instructions:"
                       [closeOnSelect]="true"
                       [searchFn]="bulkContactNameSearchFn"
                       data-testid="ddl-delivery-instruction-search">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-delivery-instruction-option_'+index">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.value}} ({{item.id}})
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="row" *ngIf="isShowBulkContactDetails">
          <div class=" col-md-4 material-select withBordr updateFontSize required">
            <ng-select name="ddlBulkContactName"
                       [items]="cppDeliveryInstructionList"
                       class="custom-select-grower grower-add-drop"
                       [(ngModel)]="cppBulkContactInfo"
                       bindLabel="contactName"
                       bindValue="contactNamePhoneNumber"
                       placeholder="Bulk Contact Name:"
                       [closeOnSelect]="true"
                       [searchFn]="bulkContactNameSearchFn"
                       (change)="getBulkContactPhone($event)"
                       (clear)="getBulkContactPhone($event)"
                       data-testid="ddl-bulk-contact-name-search"
                       [addTag]="true"
                       (keypress)="keyPressAlphaNumericWithSpace($event)"
                       [typeahead]="inputBulkContactName$"
                       (blur)="createNewContact()"
                       [inputAttrs]="{maxlength: '30'}">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div *ngIf="item.contactId" class="dropdown-template" [attr.data-testid]="'ddl-bulk-contact-name-option_'+index">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.contactName}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <!--div class="col-md-4 purchaseOrder margin-t12">
            <mat-form-field class="wide100">
              <input matInput type="text"
                     name="contactName"
                     (input)="convertFirstWordToUpperCase(blkContactName);hasHeaderInfoChanged('Bulk Name');enablePlaceOrderAndSaveOrderDraft()"
                     [(ngModel)]="blkContactName"
                     [readonly]="readOnlyAccess"
                     placeholder="Bulk Contact Name:"
                     [maxLength]="30"
                     autocomplete="off"
                     required>
            </mat-form-field>
          </div>-->
          <div class="col-md-4 purchaseOrder margin-t12">
            <mat-form-field class="wide100">
              <mat-label>Bulk Contact Phone Number:</mat-label>
              <input matInput type="text" name="contactNumber"
                     (input)="hasHeaderInfoChanged('Bulk Number');enablePlaceOrderAndSaveOrderDraft()"
                     (keypress)="keyPressPhone($event)"
                     (paste)="onPhonePaste($event, blkPhone.control)"
                     [(ngModel)]="blkContactNumber"
                     #blkPhone="ngModel"
                     [readonly]="readOnlyAccess"
                     required
                     [maxLength]="20"
                     [pattern]="phonePattern"
                     data-testid="txt-bulk-contact-number">
              <mat-error *ngIf="blkPhone.invalid && blkPhone.touched">Please enter a 10 digit phone number</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class=" d-block d-sm-block d-md-none xs-pl-10 xs-pr-10" style="background-color: #fff;">
        <button data-testid="ddl-add-product-model-open" mat-raised-button class="btns xs-button xs-full-width" *ngIf="(!readOnlyAccess)" [disabled]="!isAddProductEnable" (click)="addProduct()">Add Product</button>
      </div>
      <div class="OrderReleaseDetail">
        <!--Product Detail section-->
        <div class="form-sec">
          <div class="row margin-r0 margin-b20">
            <div class="col-md-12 filterRow">
              <div class="row">
                <div class="col-md-2">
                  <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                                [checked]="cppProductItemsDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount == cppProductItemsDataSource.data.length)"
                                [indeterminate]="cppProductItemsDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount < cppProductItemsDataSource.data.length)"
                                [style.display]="disablecheckbox || readOnlyAccess ? 'none' : 'block'"
                                (change)="enableAllCheckBoxes(Allcheck._checked);"
                                matTooltip="Select All Lines" [matTooltipPosition]="'above'"
                                data-testid="chk-select-all-product"></mat-checkbox>

                  <div class="product-tools-outer" *ngIf="showTabs && (!isSearchClicked && editToolKit)">
                    <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">

                      <div class="tab-bar margin-l15 col-md-10">
                        <ul>
                          <li (click)="showTab('delivery')" [ngClass]="{'active': tabNode==='delivery'}" class="seperator" matTooltip="Set Delivery Date" [matTooltipPosition]="'above'">
                            <i class="icon-ico-delivery"></i>
                          </li>
                          <li (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Items from Order" [matTooltipPosition]="'above'">
                            <i class="icon-ico-trash"></i>
                          </li>
                        </ul>
                      </div>

                      <div class="tab-content">
                        <div *ngIf="tabNode==='delivery'" class="deliveryDate">
                          <div class="tab-content-heading">
                            For: {{shipToAccountName}}
                          </div>
                          <div class="tab-content-detail" *ngIf="isAnyLineSMDSelected()">
                            <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                            <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                              <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused" [class.holiday]="isHoliday(date)"
                                    [class.custom-select-day]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                                {{date.day}}
                              </span>
                            </ng-template>
                            <div class="btn-Sec " *ngIf="isAnyLineSMDSelected()">
                              <div class="row">
                                <div class="col-sm-5 col-5 pr-0">
                                  <div class="pb-2">
                                    <span class="white-date-box d-inline-block align-middle"></span>
                                    <span class="calender-legend">
                                      Today's Date
                                    </span>
                                  </div>
                                  <div>
                                    <span class="green-date-box d-inline-block align-middle"></span>
                                    <span class="calender-legend">
                                      Requested Delivery
                                    </span>
                                  </div>
                                </div>
                                <div class="col-sm-7 col-7">
                                  <div class="pb-2">
                                    <span class="yellow-box d-inline-block align-middle"></span>
                                    <span class="calender-legend">
                                      Scheduled Delivery Dates
                                    </span>
                                  </div>
                                  <div>
                                    <span class="grey-date-box d-inline-block align-middle"></span>
                                    <span class="calender-legend">
                                      UnScheduled Delivery Dates
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="btn-Sec text-center">
                              <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)">Save</button>
                            </div>
                          </div>
                          <div class="tab-content-detail" *ngIf="!isAnyLineSMDSelected()">
                            <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                            <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                              <span class="custom-calendar-day" [class.weekend]="isWeekendForNonSDM(date)" [class.focused]="focused"
                                    [class.custom-select-day]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                                {{date.day}}
                              </span>
                            </ng-template>

                            <div class="btn-Sec text-center">
                              <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)">Save</button>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="tabNode==='delete'" class="delete-product">
                          <div class="tab-content-heading">
                            For: {{shipToAccountName}}
                          </div>
                          <div class="tab-content-detail">
                            <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                            <div class="btn-area">
                              <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',true)">Yes</button>
                              <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',false)">No</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 text-center diclaimermsg">
                  <div>{{this.disclaimerMessage}}</div>
                  <div>{{this.dynamicDisclaimerMessage}}</div></div>
                <div class="col-md-2 text-right showProdTxt" *ngIf="!isReleased">
                  <div class="d-none d-sm-none d-md-block">
                    <button mat-raised-button class="btns" data-testid="ddl-add-product-model-open" *ngIf="(!readOnlyAccess)" [disabled]="!isAddProductEnable" (click)="addProduct()">Add Product</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer table-mobile createOrderTable" [ngClass]="isMobileResolution ? 'material-select': 'change-dropdown'" id="cppOrderView">
              <table mat-table #productTable [dataSource]="cppProductItemsDataSource" multiTemplateDataRows matSort matSortDirection="desc" class="matTables productTable resultTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='checkbox'">
                  <th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
            </div>
            <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product </th></div>
            <div *ngIf="column=='flashmsg'"><th mat-header-cell *matHeaderCellDef class=" text-center"></th></div>
            <div *ngIf="column=='viewDetail'"><th mat-header-cell *matHeaderCellDef style="color:white" class="viewDetail text-center">View Detail</th></div>
            <div *ngIf="column=='totalGallon'"><th mat-header-cell *matHeaderCellDef class="totalGallon text-center">Total</th></div>
            <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Quantity</th></div>
            <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="orderUOMBlock text-center">Order UOM</th></div>
            <div *ngIf="column=='itemTotal'"><th mat-header-cell *matHeaderCellDef class="itemTotal text-center">Item Total</th></div>
            <div *ngIf="column=='deliveryDate'"><th mat-header-cell *matHeaderCellDef class="deliveryDateBlock text-center">Requested Arrival Date</th></div>
            <div *ngIf="column=='deliveryDateReason'" [attr.data-testid]="'ddrc_'+i"><th mat-header-cell *matHeaderCellDef class="reasonChange text-center">Arrival Date Reason Change</th></div>
            <div *ngIf="column=='inventoryAvailability'"><th mat-header-cell *matHeaderCellDef class="inventoryAvailability text-center">
               Inventory Availability <br> Last Updated : {{ lastUpdatedInv | date:'MM/dd/yyyy h:mm a'}}</th></div>
            <td mat-cell *matCellDef="let element; let i = dataIndex">
              <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol d-flex"
                   (click)="showDetails($event, element,column)"
                   matTooltip="Select Product" [matTooltipPosition]="'above'">
                <div class="mobile-box">
                  <mat-checkbox #SingleCheck class="custom-checkbox"
                                [style.display]="'contents'"
                                [disabled]="readOnlyAccess"
                                (change)="enableCheckBoxSingle(SingleCheck._checked)"
                                [(ngModel)]="element.isSelected"
                                [attr.data-testid]="'chk-specific-check_'+element.itemNumber+'_'+element.rowId"></mat-checkbox>
                </div>
                <div class="mobile-box d-sm-block d-md-none " (click)="selectForFavorite(element)" [attr.data-testid]="'btn-mob-add-remove-favourite_'+element.itemNumber+'_'+element.rowId">
                  <span class="favIcon  md-ml-20 xs-mt-0" *ngIf="!readOnlyAccess">
                    <i *ngIf="!element.isFavorite" [attr.data-testid]="'ddl-specific-non-favourite-icon_'+i" class="far fa-star"></i>
                    <i *ngIf="element.isFavorite" [attr.data-testid]="'ddl-specific-favourite-icon_'+i" class="fas fa-star"></i>
                  </span>
                </div>
              </div>
              <div *ngIf="column=='product'" class="dd-flex">
                <div class="favContainer favIcon d-none d-sm-none d-md-block" [ngClass]="{marginttop32 : ((element.yourPrice) && (plAccess==true) && (element.yourPrice!='') && (element.yourPrice!=null) && (element.yourPrice!=0))}">
                  <span (click)="selectForFavorite(element)" *ngIf="!readOnlyAccess" [attr.data-testid]="'btn-add-remove-favourite_'+element.itemNumber+'_'+element.rowId">
                    <i *ngIf="!element.isFavorite" class="far fa-star"></i>
                    <i *ngIf="element.isFavorite" class="fas fa-star"></i>
                  </span>
                </div>
                <div class="d-block d-sm-block d-md-none">Product</div>
                <div class="order-info xs-large-font pl-0">
                  <span style="width: 75%">
                    <p [attr.data-testid]="'lbl-vendor-name_'+element.itemNumber+'_'+element.rowId">{{element.itemVendorName}}</p>
                    <p class="grower-name">{{element.itemDescription}}</p>
                    <p><span *ngIf="element.yourPrice && plAccess==true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
                    <p><span *ngIf="element.paymentTerms && plAccess==true" class="paymentTerm"> {{element.paymentTerms}}</span></p>
                  </span>
                  <span *ngIf="element.isBIO" style="margin-top: 10px;width: 20%; text-align: center;">
                    <img src="../../../../assets/icon/svg/WU_Bioverified_Green.png" style="width: 30px; height: 30px" matTooltip="Winfield United Bioverified" [matTooltipPosition]="'above'" />
                  </span>
                </div>

                <span class="favIcon position-relative" *ngIf="element.warningMessage">
                  <i class="warning-icon" mat-raised-button
                     matTooltip="{{element.warningMessage}}"
                     [matTooltipPosition]="'above'" matTooltipClass='red-tooltip' [attr.data-testid]="'lbl-hover-warning-message_'+element.itemNumber+'_'+element.rowId"></i>
                </span>

              </div>
              <div *ngIf="column=='flashmsg'">
                <div [ngClass]="{'order-info-outer-flash-message' :((element.itemFlashMsgDesc!='') && (element.itemFlashMsgDesc!=null))}" *ngIf="element.itemFlashMsgDesc!=''">
                  {{element.itemFlashMsgDesc}}
                </div>
              </div>
              <div *ngIf="column=='viewDetail'" (click)="showProductDetails(element);" class="showHideDetails md-pt-0" [attr.data-testid]="'btn-show-product-details_'+element.itemNumber+'_'+element.rowId">
                <a>{{element.isProductDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
              </div>
              <div *ngIf="column=='totalGallon'" class="measureUnit text-center largeTableTxt mobile-col-set">
                <div class="d-block d-sm-block d-md-none">Total</div>
                <div class="m-center" [attr.data-testid]="'lbl-specific-gallon_'+element.itemNumber+'_'+element.rowId">{{element.totalGlnPnd | number: '1.2-2':'en-US'}} {{element.measurementGlnPnd}}</div>
              </div>
              <div *ngIf="column=='quantity'" class="quantityBlock text-center largeTableTxt landscape-miw-101">
                <div class="d-block d-sm-block d-md-none">QTY</div>
                <div class="xs-ml-20 md-ml-0">
                  <button *ngIf="!readOnlyAccess" class="plus-minus-btn minusBtn" (click)="cppUnitChange('decrease',element)" [attr.data-testid]="'btn-specific-minus_'+element.itemNumber+'_'+element.rowId"> - </button>
                  <input *ngIf="!element.allowDecimal" [readonly]="readOnlyAccess" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="10" NumbersOnly [ngClass]="{'invalid-txt': (element.quantity<=0 || element.quantity=='')}" [attr.data-testid]="'txt-specific-qty_'+element.itemNumber+'_'+element.rowId" />
                  <input *ngIf="element.allowDecimal" [readonly]="readOnlyAccess" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="10" NumbersOnly [allowDecimals]="true" [ngClass]="{'invalid-txt': (element.quantity==0 || element.quantity=='')}" [attr.data-testid]="'txt-specific-qty_'+element.itemNumber+'_'+element.rowId" />
                  <button *ngIf="!readOnlyAccess" class="plus-minus-btn plusBtn" (click)="cppUnitChange('increase',element)" [attr.data-testid]="'btn-specific-plus_'+element.itemNumber+'_'+element.rowId"> + </button>
                </div>
              </div>
              <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt mobile-col-set" [attr.data-testid]="'lbl-order-uom_'+element.itemNumber+'_'+element.rowId">
                <div class="d-block d-sm-block d-md-none">UOM</div>
                <div class="m-center"> {{element.uom}}</div>
              </div>
              <div *ngIf="column=='deliveryDate'" class="deliveryDateBlock mobile-col-set">
                <div class="d-block d-sm-block d-md-none">Requested Arrival Date</div>
                <div class="text-center deliveryDatePicker padding-t10 m-center">
                  <mat-form-field [class.invalid-field]="element.deliveryDate ? false : true">
                    <input
                      readonly
                      matInput
                      (focus)="openCalendar(element)"
                      (click)="openCalendar(element)"
                      [attr.data-testid]="'txt-request-delivery_'+element.itemNumber+'_'+element.rowId"
                      [max]="element.bulkPackaged == 'BULK' ? maxDateBulk : maxDate"
                      [(ngModel)]="element.deliveryDate"
                      (dateChange)="validateDate(element, $event)">
                    
                    <mat-icon
                      matSuffix
                      (click)="openCalendar(element)"
                      [attr.data-testid]="'btn-request-delivery_'+element.itemNumber+'_'+element.rowId"
                      class="calendar-day">
                    </mat-icon>
                  </mat-form-field>
                  
                  <!-- Backdrop (click to close calendar) -->
                  <div class="calendar-backdrop" *ngIf="element.openDatepicker" (click)="closeCalendar(element)"></div>
                  
                  <!-- Ngb Datepicker -->
                  <div class="tab-content-detail" *ngIf="element.openDatepicker" #calendarContainer>
                    <ngb-datepicker
                      [(ngModel)]="requestDatemodel"
                      [dayTemplate]="requestCustomDay"
                      [markDisabled]="isDisabled"
                      #dp="ngbDatepicker"
                      (ngModelChange)="onDateSelect(requestDatemodel, element)">
                    </ngb-datepicker>                  

                    <ng-template #requestCustomDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                      <span class="custom-day"
                            [class.weekend]="!element.isLineSDM ? true : isWeekend(date)"
                            [class.focused]="focused"
                            [class.holiday]="isRequestHoliday(date, element)"
                            [class.custom-select-day]="selected"
                            [class.hidden]="date.month !== currentMonth"
                            [class.text-muted]="disabled"
                            [attr.data-testid]="requestDateType(date, element)">
                        {{date.day}}
                      </span>
                    </ng-template>

                    <!-- Footer with Calendar Legend -->
                    <div class="btn-Sec" *ngIf="element.isLineSDM">
                      <div class="row">
                        <div class="col-sm-5 col-5 pr-0">
                          <div class="pb-2 text-left">
                            <span class="white-date-box d-inline-block align-middle"></span>
                            <span class="calender-legend">Today's Date</span>
                          </div>
                          <div>
                            <span class="green-date-box d-inline-block align-middle"></span>
                            <span class="calender-legend">Requested Delivery</span>
                          </div>
                        </div>
                        <div class="col-sm-7 col-7">
                          <div class="pb-2 text-left">
                            <span class="yellow-box d-inline-block align-middle"></span>
                            <span class="calender-legend">Scheduled Delivery Dates</span>
                          </div>
                          <div>
                            <span class="grey-date-box d-inline-block align-middle"></span>
                            <span class="calender-legend">UnScheduled Delivery Dates</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="reasonChange mobile-col-set" *ngIf="column=='deliveryDateReason' && isAccontSDM && !isCustomerPickup && element.isReasonMandatory">
                <div class="d-block d-sm-block d-md-none">Arrival Date Reason Change</div>
                <div class="padding-r0">
                  <div class="reason-dropdown material-select m-center">
                    <ng-select class="mobile-view-dropdown"
                               name="reasonChange"
                               [(ngModel)]="element.deliveryDateReason"
                               [virtualScroll]="true"
                               [closeOnSelect]="true"
                               [selectOnTab]="true"
                               [clearable]="false"
                               bindValue="id"
                               (change)="reasonCodeChange(element)"
                               [searchable]="false"
                               placeholder="{{element.deliveryDateReason ? '' : 'Select one'}}"
                               appendTo=".createOrderTable"
                               required="element.isReasonMandatory"
                               [ngClass]="{'reason-error-border': element.lineErrors.errors.length > 0}"
                               [attr.data-testid]="'ddl-delivery-reason_'+element.itemNumber+'_'+element.rowId">
                      <ng-option *ngFor="let data of reasonList;let index=index" [value]="data.id">
                        <span [attr.data-testid]="'ddl-delivery-reason-option_'+element.itemNumber+'_'+element.rowId">{{data.value}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                  <!--<div class="red-error-msg" *ngIf="element.isReasonMandatory && !element.deliveryDateReason">
        Please enter Reason Code.
      </div>-->
                </div>
              </div>

              <div *ngIf="column=='inventoryAvailability' && element.inventoryTag" class="text-center d-md-inline-flex justify-content-center">
                <div class="d-block d-sm-block d-md-none text-xs-center text-sm-center" style="font-size: 18px;">Inventory Availability <br><span style="text-transform: uppercase; font-size: 12px;">Last Updated : {{ lastUpdatedInv | date:'MM/dd/yyyy h:mm a'}}</span> </div>
                <div class="availabilitySection">
                  <a matTooltip={{element.inventoryHover}} #tooltip="matTooltip"
                     [matTooltipPosition]="'below'" (mouseenter)="$event.stopImmediatePropagation()"
                     (mouseleave)="$event.stopImmediatePropagation()" (click)="tooltip.show()" matTooltipClass='cpp-stop-Light-tooltip'>
                    <div class="d-flex align-items-center">
                      <span class="legends" [ngClass]="element.inventoryStopLightClass"></span>
                      <span class="textAvailablity">
                        {{element.inventoryTag}}
                      </span>
                      <span class="m-auto">
                        <i class="arrow down"></i>
                      </span>
                    </div>
                  </a>
                </div>

              </div>

            </td>
            <td>
              Additional Requested Arrival Date:
            </td>
            </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div [style.display]="element.isProductDetailDisplayed ? 'block' : 'none'">
                  <div class="cpp-prod-info mobile-nested-table">
                    <table style="width:100%">
                      <thead>
                        <tr>
                          <th width="10%" class="text-left">Item #</th>
                          <th width="12%">GTIN</th>
                          <th width="12%">Product Line</th>
                          <th width="18%">Active Ingredients</th>
                          <!--<th width="10%">National Price</th>-->
                          <th width="11%">Pallet Quantity</th>
                          <th width="11%">Restricted Use</th>
                          <th width="13%">Non-Returnable</th>
                          <th width="13%">Package Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <!-- Responsive heading cells for small devices -->
                          <th width="10%" class="d-block d-sm-block d-md-none">Item #</th>
                          <td width="10%" class="text-left"><p>{{element.itemNumber}}</p></td>

                          <th width="12%" class="d-block d-sm-block d-md-none">GTIN</th>
                          <td width="12%"><p>{{element.gtin}}</p></td>

                          <th width="12%" class="d-block d-sm-block d-md-none">Product Line</th>
                          <td width="12%"><p>{{element.productLine}}</p></td>

                          <th width="18%" class="d-block d-sm-block d-md-none sm-block">Active Ingredients</th>
                          <td width="18%"><p>{{element.activeIngredient}}</p></td>

                          <!--<th width="10%" class="d-block d-sm-block d-md-none">National Price</th>
        <td width="10%"><p>{{element.price | number:'1.4-4'}}</p></td>-->

                          <th width="11%" class="d-block d-sm-block d-md-none sm-block">Pallet Quantity</th>
                          <td width="11%"><p>{{element.palletQuantity | number:'1.4-4'}}</p></td>

                          <th width="11%" class="d-block d-sm-block d-md-none">Restricted Use</th>
                          <td width="11%"><p>{{element.restrictedUse}}</p></td>

                          <th width="13%" class="d-block d-sm-block d-md-none sm-block">Non-Returnable</th>
                          <td width="13%">
                            <div [ngClass]="{'oval-shape returnable':(element.returnable === 'X')}">
                              <p>{{element.returnable}}</p>
                            </div>
                          </td>

                          <th width="13%" class="d-block d-sm-block d-md-none">Package Size</th>
                          <td width="13%"><p>{{element.packageSize}}</p></td>
                        </tr>

                        <tr *ngIf="element.warningMessage">
                          <td mat-cell class="product-details" colspan="8">
                            <div class="inline-error red-inline-error m-0">
                              <div class="row">
                                <div class="error-msg" [attr.data-testid]="'lbl-warning-message_'+element.itemNumber+'_'+element.rowId">
                                  {{element.warningMessage}}
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="inline-error red-inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-10">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors" [attr.data-testid]="'lbl-error-message_'+element.itemNumber+'_'+element.rowId">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-2 revertToPrev hide" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <!--warning message column-->
            <ng-container matColumnDef="showWarning">
              <td mat-cell [attr.colspan]="displayedColumns.length" *matCellDef="let element" style="background: #FDCF35" [style.display]="(element.isRepackItem=='Y' && element.repackAgreement=='N')|| (element.isRepackItem=='Y' && element.repackAgreement==null) || (element.isRepackItem=='Y' && element.repackAgreement=='')? '' : 'none'">
                <div *ngIf="(element.isRepackItem=='Y' && element.repackAgreement=='N')|| (element.isRepackItem=='Y' && element.repackAgreement==null) || (element.isRepackItem=='Y' && element.repackAgreement=='')">
                  <span class="summary-status-bar">
                    1. A Repack Agreement is expired or missing for {{element.itemDescription}} ,{{element.itemNumber}}. This item will not ship until a repack agreement has been signed.
                  </span>
                  <br />
                  <span class="summary-status-bar">
                    Please reach out to winfieldcustomerservice&#64;landolakes.com or 855-494-6343 to get an agreement sent.
                  </span>
                </div>
              </td>
            </ng-container>
            <!-- Secondary Column -->
            <ng-container matColumnDef="secondary">
              <td mat-cell [attr.colspan]="displayedColumns.length"
                  *matCellDef="let element" class="additionalDate" [ngClass]="{'maximumText': element.isBulkSetup == true && element.isBulkRowExceed == true}">
                <div class="text-right" *ngIf="element.isBulkSetup == true && element.isBulkRowExceed == false">
                  Additional Requested Arrival Date:   <span class="showHideicons ml-3 float-r handCursor" (click)="CreateNewRow(element)" [attr.data-testid]="'btn-additional-row_'+element.itemNumber"><i class="icon-ico-Plus"></i></span>
                </div>
                <div class="text-right " *ngIf="element.isBulkSetup == true && element.isBulkRowExceed == true">
                  Maximum number of additional Requested Arrival Dates reached for this product. Create New Order to continue.
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['showWarning']" class="example-detail-row"></tr>
            <tr mat-row *matRowDef="let element; columns: ['secondary'];" [hidden]="element.isBulkSetup != true"></tr>
            </table>
            <div *ngIf="cppProductItemsDataSource == undefined || cppProductItemsDataSource?.data.length == 0" class="noDataMsg">
              <p>No Record Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Error section on table-->
  <div class="common-error-block cpp-create red-inline-error" *ngIf="showErrorBlock && errorMsgs.length > 0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-2 col-sm-2 col-md-2 padding-r0 errCountOuter">
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-10 col-sm-6 col-md-6 padding-l0 ">
        <ol class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors; let i=index">
            {{i+1}}. {{err.error}}
          </li>
        </ol>
      </div>
      <div class="col-12 col-sm-4 col-md-4 button-sec text-right">
        <!--<button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>-->
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>1" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row padding-l20">
      <div class="col-md-12 mobile-footer" style="display: contents;">
        <button mat-raised-button class="btns" data-testid="ddl-place-cpp-order" [disabled]="(!isPlaceOrderEnable) || (isNotValid ==  true)" (click)="validateplaceOrder()" [style.display]="'inline-block' ">Place Order</button>
        <button mat-raised-button class="btns" data-testid="ddl-save-cpp-draft" color="primary" (click)="saveDraft()" [disabled]="!isSaveOrderDraftEnable || (isNotValid ==  true)" [style.display]="'inline-block'">Save Draft</button>
      </div>
    </div>
  </div>
</div>
